module.exports = __webpack_public_path__ + "static/media/newPalpation_mobile.813c58ed.png";